import {
  ProcedureId,
  ProcedureStatus,
  ProcedureType,
  ProcedureDateLimit,
  Province
} from '@/Domain/Procedures'
import { DogaInfo } from '@/Domain/Procedures/Doga'
import { CelebrationInfo } from '@/Domain/Procedures/Celebration'

export class Procedure {
  private _procedureId: ProcedureId
  private _status: ProcedureStatus
  private _type: ProcedureType
  private _province: Province
  private _dogaInfo: DogaInfo
  private _celebrationInfo: CelebrationInfo
  private _dateLimit: ProcedureDateLimit

  constructor (
    procedureId: ProcedureId,
    procedureType: ProcedureType,
    procedureStatus: ProcedureStatus,
    province: Province,
    dogaInfo: DogaInfo,
    celebrationInfo: CelebrationInfo,
    dateLimit: ProcedureDateLimit
  ) {
    if (procedureStatus === ProcedureStatus.DRAFT) {
      throw new TypeError('Procedures in draft status are not allowed')
    }
    this._procedureId = procedureId
    this._status = procedureStatus
    this._type = procedureType
    this._province = province
    this._dogaInfo = dogaInfo
    this._celebrationInfo = celebrationInfo
    this._dateLimit = dateLimit
  }

  procedureId (): string {
    return this._procedureId.id
  }

  procedureType (): ProcedureType {
    return this._type
  }

  status (): ProcedureStatus {
    return this._status
  }

  province (): Province {
    return this._province
  }

  dogaUrl (): string {
    return this._dogaInfo.dogaUrl()
  }

  dogaDate (): string {
    return this._dogaInfo.publishDate()
  }

  dogaNumber (): number {
    return this._dogaInfo.dogaNumber()
  }

  celebrationPlace (): string {
    return this._celebrationInfo.celebrationPlace()
  }

  celebrationDate (): string {
    return this._celebrationInfo.celebrationDate()
  }

  celebrationTime (): string {
    return this._celebrationInfo.celebrationTime()
  }

  dateLimit (): string {
    return this._dateLimit.date()
  }
}
